<template>
  <div class="download_container">
    <!-- <div @click="download">下载iOS</div>
    <div @click="downloadA">下载安卓</div> -->
    <div class="download_right"></div>
    <div class="download_left"></div>
    <div class="logo"></div>
    <div class="car"></div>
    <div @click="downloadA" class="and"></div>
    <!-- <div @click="download" class="ios"></div> -->
    <div class="layer" v-if="layerShow" @click="hide">
      <div class="prompt"></div>
    </div>
    <!-- <div class="ios_message">
    </div> -->
  </div>
</template>

<script>
import { isMiniProgram, isiOS } from "../../utils/util";
import { Toast } from "vant";
export default {
  data() {
    return {
      layerShow: false,
      iosMessage:
        "IOS下载后需要信任认证 > 点击设置 > 通用 > 设备管理 > ZhongshengHoldings...信任 > 完成",
    };
  },
  components: {},
  mounted() {
    document.title = "中升GO";
    if (!isMiniProgram() && !isiOS() && this.hasAppStore()) {
      window.location.href = "market://details?id=com.lzkj.zsgo";
    }
  },
  methods: {
    download() {
      var ua = navigator.userAgent.toLowerCase();

      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // alert("请使用Safari打开页面");
        this.layerShow = true;
        return;
      }

      var itmsUrl;
      if (location.href.indexOf("test") == -1) {
        const plistUrl =
          "https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/package/prod/app.plist";
        itmsUrl = `itms-services://?action=download-manifest&url=${plistUrl}`;
      } else {
        const plistUrl =
          "https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/package/uat/app.plist";
        itmsUrl = `itms-services://?action=download-manifest&url=${plistUrl}`;
      }
      window.location.href = itmsUrl;
    },
    downloadA() {
      if (isMiniProgram()) {
        // 调用函数将固定文字复制到剪贴板
        this.copyToClipboard("https://mall.zs-group.com.cn/h5/#/app/download");
        return;
      }

      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.layerShow = true;
        return;
      }
      if (!isMiniProgram() && !isiOS() && this.hasAppStore()) {
        window.location.href = "market://details?id=com.lzkj.zsgo";
        return;
      }
      if (location.href.indexOf("test") == -1) {
        window.location.href =
          "https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/package/prod/ZSGO-release-v1.5.1.apk";
      } else {
        window.location.href =
          "https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/package/uat/ZSGO-debug-v1.1.0.apk";
      }
    },
    copyToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      Toast("已复制地址,请在浏览器中打开哦");
      //
    },

    hide() {
      this.layerShow = false;
    },
    hasAppStore() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isHuaWei = userAgent.match(/huawei/i) || userAgent.match(/honor/i);
      // const isHuaWei = userAgent.match(/honor/i);
      const isXiaomi =
        userAgent.match(/xiaomi/i) ||
        userAgent.match(/mi\s/i) ||
        userAgent.match(/mix\s/i) ||
        userAgent.match(/redmi/i);
      const isOppo = userAgent.match(/oppo/i) || userAgent.match(/heytap/i);
      const isVivo = userAgent.match(/vivo/i) || userAgent.match(/PACM00/i);
      const isSamsung = userAgent.match(/samsung/i) || userAgent.match(/sm-/i);
      console.log(userAgent);
      return isHuaWei || isXiaomi || isOppo || isVivo || isSamsung;
    },
  },
};
</script>

<style>
.doc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  font-size: 0.24rem;
}

.download_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.download_right {
  width: 4.65rem;
  height: 4.69rem;
  position: absolute;
  right: 0;
  top: 0;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/appH5/10241024-A.png);
  background-size: 100% auto;
}

.download_left {
  width: 4.82rem;
  height: 4.78rem;
  position: absolute;
  left: 0;
  bottom: 0;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/appH5/10241024-A%20%E6%8B%B7%E8%B4%9D.png);
  background-size: 100% auto;
}

.logo {
  width: 3.39rem;
  height: 2.83rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/appH5/%E7%BB%84%205.png);
  background-size: 100% auto;
}

.car {
  width: 0.66rem;
  height: 0.77rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/appH5/%E5%9B%BE%E5%B1%82%203.png);
  background-size: 100% auto;
  margin-top: 1.25rem;
  margin-right: 2.8rem;
}

.and {
  width: 3.37rem;
  height: 0.7rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/appH5/%E7%BB%84%204.png);
  background-size: 100% auto;
  margin-top: 0.88rem;
  z-index: 1;
}

.ios {
  width: 3.37rem;
  height: 0.7rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/appH5/%E7%BB%84%203.png);
  background-size: 100% auto;
  margin-top: 0.4rem;
  z-index: 1;
}

.layer {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1;
}

.prompt {
  width: 4.12rem;
  height: 1.4rem;
  position: absolute;
  right: 0.3rem;
  top: 0.3rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/appH5/%E7%BB%84%202.png);
  background-size: 100% auto;
}
/* .ios_message{
  bottom: 30px;
  width: 80%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-family: 'Helvetica', 'Arial', sans-serif;
  font-size: 15px;
  color: #333;
  line-height: 1.5;
  text-align: justify;
  letter-spacing: 0.5px;
  font-weight: bold;
  border-radius: 10px;
  padding: 10px;
  background: linear-gradient(45deg, rgba(173, 216, 230, 0.5), rgba(255, 182, 193, 0.5));
  margin-top: 0.5rem;
  margin-bottom: 0.2rem;
} */

.ios_message {
  width: 5.41rem;
  height: 1.16rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/appH5/%E7%BB%84%201.png);
  background-size: 100% auto;
  margin-top: 1.3rem;
}
</style>
